export class PaymentReceivedAmountSearchOption {

    constructor(
        public id: number,
        public name: string
    ){}
}
